import client, { TXN_BASE_URL } from 'services/kardAPI';

const reprocessIncomingTransaction = async (id, body) => {
  try {
    await client.put(`${TXN_BASE_URL}/portal/incomingtransaction/${id}`, body);
  } catch (error) {
    throw new Error(error.message);
  }
};

export default reprocessIncomingTransaction;
